import type { CSSProperties, ReactNode } from "react";

export type MicroLabelColor =
  | "default"
  | "accent"
  | "signal-cyan"
  | "signal-red"
  | "signal-green"
  | "signal-violet";

export type MicroLabelProps = {
  children: ReactNode;
  color?: MicroLabelColor;
  className?: string;
  style?: CSSProperties;
  /** Render as a heading when the label actually heads a group. */
  as?: "span" | "h2" | "h3" | "h4";
};

/**
 * MicroLabel — tiny uppercase metadata tag (10-12px mono, tracked).
 * Used for SKILL FAMILY, BAND, snap-latency unit suffixes, etc.
 */
export function MicroLabel({
  children,
  color = "default",
  className,
  style,
  as,
}: MicroLabelProps) {
  // `as` exists so a label that genuinely HEADS a group can be a heading.
  // On Home, the exam-group labels ("SAT", "ACT") name the grid of subject
  // tiles beneath them, but rendered as a span they were invisible to the
  // heading navigation a screen-reader user relies on to move between
  // sections: the page offered one landmark where it has three.
  const Tag = as ?? "span";
  return (
    <Tag
      className={["bht-label", `bht-label--${color}`, className]
        .filter(Boolean)
        .join(" ")}
      style={style}
    >
      {children}
    </Tag>
  );
}
